export default __webpack_public_path__ + "static/media/DNo.13-5.c05bc6ef.jpg";